module.exports = __webpack_public_path__ + "static/media/fly0190.9c28652f.webp";